import { createContext } from 'react';

import { LayoutWrapContextType } from './types/LayoutWrapContext';

export const LayoutWrapContext = createContext<
  LayoutWrapContextType | undefined
>(undefined);
